module.exports = __webpack_public_path__ + "static/media/logo.03b90dcf.svg";